import { HighlightDecorator } from 'modules/common/components';

const highlightDecoratorPlugin = {
  decorators: [HighlightDecorator],
};

export default highlightDecoratorPlugin;
